export default __webpack_public_path__ + "static/media/EG.74fe3155.svg";